module.exports = __webpack_public_path__ + "img/PCHeaderComponent@4x.f94dc2ef.png";